import React from 'react';
import Choice from './Choice'

const Select = ({ choices, handleAnswer, selectedAnswer}) => {
  return (
    <div className="text-[20px] font-semibold py-4 choice__container">
      {choices.map((choice, index) => (
        choice.length ? (
          <Choice
            key={index}
            id={index}
            choice={choice}
            handleAnswer={handleAnswer}
            selectedAnswer={selectedAnswer}
          />
        ) : <div key={index} className="line" />
      ))}
    </div>
  );
};

export default Select;
